import React from "react";

const KPISkeleton = () => {
  return (

     <>
        <div className="flex items-center gap-2 pl-2 mb-4">
        <div className="h-6 w-6 bg-gray-200 rounded animate-pulse"></div>
        <div className="h-6 w-48 bg-gray-200 rounded animate-pulse"></div>
      </div>

      {/* KPI Cards Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className="bg-white p-5 rounded-xl shadow flex justify-between items-center animate-pulse"
          >
            <div className="flex-1">
              <div className="h-4 w-32 bg-gray-200 rounded mb-2"></div>
              <div className="h-8 w-20 bg-gray-300 rounded mb-2"></div>
              <div className="h-3 w-24 bg-gray-200 rounded"></div>
            </div>
            <div className="h-12 w-12 bg-gray-200 rounded-lg"></div>
          </div>
        ))}
      </div>
     </>
   

     
 
  );
};

export default KPISkeleton;

